export const GET_TIME_SLOTS = "GET_TIME_SLOTS";
